document.addEventListener('DOMContentLoaded', () => {

    $('[data-tabnav-id]').click(function() {
        let id = $(this).attr('data-tabnav-id');
        let wrap = $(this).closest('.tab-wrap');
        wrap.find('[data-tabnav-id]').removeClass('is-active');
        $(this).addClass('is-active');
        wrap.find('[data-tabcontent-id]').removeClass('is-active');
        wrap.find(`[data-tabcontent-id=${id}]`).addClass('is-active');

        if ($(this).closest('.modal-land-area'.length)) {
            PubSub.publish(CHANNEL_NAMES.updModalLandMapBounds, {})
        }
    });

    $('.area-block').on('click', '.area-card', function (e) {
        e.preventDefault();
        const id = $(this).data('area-id');
        PubSub.publish(CHANNEL_NAMES.landShowInfo, {landID: id})
    });

});